import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { CONTACT_PATH, SUPPORT_PATH } from './../../config/routes'

const SupportBlock = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="support-block-wrapper text-center">
        <Button
          variant="primary"
          as={Link}
          to={SUPPORT_PATH}
          className="btn-margin-10"
          style={{ margin: '0 5px' }}
        >
          {t('TO_SUPPORT_ME')}
        </Button>
        <Button
          variant="primary"
          as={Link}
          to={CONTACT_PATH}
          className="btn-margin-10"
          style={{ margin: '0 5px' }}
        >
          {t('TO_CONTACT_ME')}
        </Button>
      </div>
    </div>
  )
}

export default SupportBlock
